import keyIssueItemConnector from "../key-issue-item-connector"
import KeyIssueViewItem from "./KeyIssueViewItem"

export default keyIssueItemConnector(KeyIssueViewItem)
